import { CloseOutlined, DownloadOutlined, SaveOutlined } from "@ant-design/icons";
import { Button, message, Modal, Table } from "antd";
import { FileList, RebateAndCogsData } from "../../data";
import { useState } from "react";
import { axiosInstance } from "../../utils/axiosInterceptor";
import * as XLSX from 'xlsx';

const AutomationFileModal = ({
  open,
  hide,
  fileType,
  selectedFileData,
  isLoading,
  fileData
}) => {
  const [pagination, setPagination] = useState(10);
  const [loading, setLoading] = useState(false)

  const downloadFile = async (record) => {
    const payload = {
      id: record?.Id,//"1",
      fileId: record.FileId,//"10",
      accountNumber: record.accountNumber //"123456",
    };
    setLoading(record.Id)
    try {
      const response = await axiosInstance.post(
        `/reports/get-rebate-pdf`,
        payload, {
        responseType: "blob", // required for binary files
      }
      );

      const fileURL = window.URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }));
      window.open(fileURL);
    } catch (error) {
      console.log(error, "erroror");
    } finally {
      setLoading(false)
    }
  };
  const CogsCoumn = [
    {
      title: "File ID",
      dataIndex: "FileId",
      key: "FileId",
    },
    {
      title: "Primary Account",
      dataIndex: "PRIMARY_ACCT",
      key: "PRIMARY_ACCT",
    },
    
    {
      title: "Account Id",
      dataIndex: "ACCT_ID",
      key: "ACCT_ID",
    },
    {
      title: "Lock ID",
      dataIndex: "INA_LOC_ID",
      key: "INA_LOC_ID",
      render: (value) => value === null || value === undefined ? "null" : value
    },
    {
      title:"Store Name",
      dataIndex:"STORE_NAME",
      key:"STORE_NAME"
    },
    {
      title:"MCK RX Amount",
      dataIndex:"RX_AMT",
      key:"RX_AMT",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title:"MCK Generic RX Amount",
      dataIndex:"GRX_AMT",
      key:"GRX_AMT",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title:"MCK HIV Amount",
      dataIndex:"HIV_AMT",
      key:"HIV_AMT",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title:"MCK GCR %",
      dataIndex:"GCR",
      key:"GCR",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title:"Portal RX Amount",
      dataIndex:"Portal_RX",
      key:"Portal_RX",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title:"Portal Generic RX Amount",
      dataIndex:"Portal_GRX",
      key:"Portal_GRX",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },

    {
      title:"Portal HIV Amount",
      dataIndex:"Portal_HIV",
      key:"Portal_HIV",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title:"Portal GCR %",
      dataIndex:"Portal_GCR",
      key:"Portal_GCR",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title:"RX DIFF",
      dataIndex:"RX_DIFF",
      key:"RX_DIFF",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
      // render: (value) => <span className="cardtitle ">{value?.toFixed(2)}</span>
    },
    {
      title:"Generic RX DIFF",
      dataIndex:"GRX_DIFF",
      key:"GRX_DIFF",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
      // render: (value) => <span className="cardtitle ">{value?.toFixed(2)}</span>
    },
    {
      title:"GCR DIFF",
      dataIndex:"GCR_DIFF",
      key:"GCR_DIFF",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
      // render: (value) => <span className="cardtitle ">{value?.toFixed(2)}</span>
    },
    {
      title:"HIV DIFF",
      dataIndex:"HIV_DIFF",
      key:"HIV_DIFF",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
      // render: (value) => <span className="cardtitle ">{value?.toFixed(2)}</span>
    },
    // {
    //   title:"Quarter Label",
    //   dataIndex:"QuarterLabel",
    //   key:"QuarterLabel",
    // },
  ];

  // const CogsCoumn = [
  //   {
  //     title: "File ID",
  //     dataIndex: "FileId",
  //     key: "FileId",
  //   },
  //   {
  //     title: "Account Id",
  //     dataIndex: "ACCT_ID",
  //     key: "ACCT_ID",
  //   },

  //   {
  //     title: "Lock ID",
  //     dataIndex: "INA_LOC_ID",
  //     key: "INA_LOC_ID",
  //     render: (text, record) => (
  //       <span className="flex gap-2">{text === null ? "null" : text}</span>
  //     ),
  //   },

  //   {
  //     title: "CUR BRX File",
  //     dataIndex: "Current_BRX_COG",
  //     key: "Current_BRX_COG",
  //     render: (text, record) => (
  //       <span className="flex gap-2">{text.toFixed(2)}</span>
  //     ),
  //   },

  //   {
  //     title: "COG",
  //     dataIndex: "Final_COGS",
  //     key: "Final_COGS",
  //     render: (text, record) => (
  //       <span className="flex gap-2">{text.toFixed(2)}</span>
  //     ),
  //   },

  //   {
  //     title: "GCR",
  //     dataIndex: "GCR",
  //     key: "GCR",
  //   },

  //   {
  //     title: "Month",
  //     dataIndex: "Month",
  //     key: "Month",
  //   },
  //   //  {
  //   //   title: "Action",
  //   //   key: "action",
  //   //   render: (record) => (
  //   //     <div className="flex gap-2">
  //   //       <Button >
  //   //         Download
  //   //       </Button>
  //   //     </div>
  //   //   ),
  //   // },
  // ];
  // const Rebatecolumns = [
  //   {
  //     title: "Account Number",
  //     dataIndex: "accountNumber",
  //     key: "accountNumber",
  //   },
  //   {
  //     title: "Account Name",
  //     dataIndex: "accountName",
  //     key: "accountName",
  //   },

  //   {
  //     title: "GCR Ratio",
  //     dataIndex: "gcrPer",
  //     key: "gcrPer",
  //   },

  //   {
  //     title: "SGCR Ratio",
  //     dataIndex: "sgcrPer",
  //     key: "sgcrPer",
  //   },

  //   {
  //     title: "GPR Ratio",
  //     dataIndex: "gprPer",
  //     key: "gprPer",
  //   },

  //   // {
  //   //   title: "Exception Reason",
  //   //   dataIndex: "ExceptionReason",
  //   //   key: "ExceptionReason",
  //   // },

  //   {
  //     title: "Rebate Statement",
  //     key: "action",
  //     render: (record) => (
  //       <div className="flex gap-2">
  //         <Button onClick={() => downloadFile(record)} loading={loading === record.Id}>Download</Button>
  //       </div>
  //     ),
  //   },
  // ];
   const Rebatecolumns = [
    {
      title: "ID",
      dataIndex: "Id",
      key: "Id",
    },
    {
      title: "File ID",
      dataIndex: "FileId",
      key: "FileId",
    },
    {
      title: "Customer Group",
      dataIndex: "customerGroup",
      key: "customerGroup",
    },
     {
      title: "Customer Name",
      dataIndex: "customerName",
      key: "customerName",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Account Number",
      dataIndex: "accountNumber",
      key: "accountNumber",
    },
    {
      title: "Account Name",
      dataIndex: "accountName",
      key: "accountName",
    },
    //  {
    //   title: "Total Rebate Amount",
    //   dataIndex: "totalRebateamount",
    //   key: "totalRebateamount",
    // },
    {
      title: "SYS Total RX",
      dataIndex: "sys_Total_Rx",
      key: "sys_Total_Rx",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title: "SYS Speciality",
      dataIndex: "sys_Specialty",
      key: "sys_Specialty",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title: "SYS Generic Rx",
      dataIndex: "sys_Generic_Rx",
      key: "sys_Generic_Rx",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title: "MCK GCR %",
      dataIndex: "gcrPer",
      key: "gcrPer",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },

    {
      title: "MCK SGCR %",
      dataIndex: "sgcrPer",
      key: "sgcrPer",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },

    {
      title: "MCK GPR %",
      dataIndex: "gprPer",
      key: "gprPer",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title: "SYS SGCR %",
      dataIndex: "sys_SGCR_Percentage",
      key: "sys_SGCR_Percentage",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title: "SYS GCR %",
      dataIndex: "sys_GCR_Percentage",
      key: "sys_GCR_Percentage",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title: "SYS GPR %",
      dataIndex: "sys_GPR_Percentage",
      key: "sys_GPR_Percentage",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
     {
      title: "MCK Generic GCR Rebate %",
      dataIndex: "genericsgcrper",
      key: "genericsgcrper",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
     {
      title: "MCK Generic GPR Rebate %",
      dataIndex: "genericgprper",
      key: "genericgprper",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
     {
      title: "MCK Brand GCR Rebate %",
      dataIndex: "brandsgcrper",
      key: "brandsgcrper",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
     {
      title: "MCK Brand GPR Rebate %",
      dataIndex: "brandgprper",
      key: "brandgprper",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title: "SYS Generic GCR  %",
      dataIndex: "sys_generic_sgcr_per",
      key: "sys_generic_sgcr_per",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title: "SYS Generic GPR  %",
      dataIndex: "sys_generic_gpr_per",
      key: "sys_generic_gpr_per",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title: "SYS Brand GCR  %",
      dataIndex: "sys_brand_sgcr_per",
      key: "sys_brand_sgcr_per",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title: "SYS Brand GPR  %",
      dataIndex: "sys_brand_gpr_per",
      key: "sys_brand_gpr_per",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title: "SYS Generic GCR Amount",
      dataIndex: "eligiblegenericsgcr",
      key: "eligiblegenericsgcr",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title: "SYS Generic GPR Amount",
      dataIndex: "eligiblegenericgpr",
      key: "eligiblegenericgpr",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    }, {
      title: "SYS Brand GCR Amount",
      dataIndex: "eligiblebrandsgcr",
      key: "eligiblebrandsgcr",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    }, {
      title: "SYS Brand GPR Amount",
      dataIndex: "eligiblebrandgpr",
      key: "eligiblebrandgpr",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    //  {
    //   title: "MCK Generic GCR Amount",
    //   dataIndex: "earned_gcr_generic_file",
    //   key: "earned_gcr_generic_file"
    // }, {
    //   title: "MCK Generic GPR Amount",
    //   dataIndex: "earned_gpr_generic_file",
    //   key: "earned_gpr_generic_file"
    // }, {
    //   title: "MCK Brand GCR Amount",
    //   dataIndex: "earned_gcr_brand_file",
    //   key: "earned_gcr_brand_file"
    // }, {
    //   title: "MCK Brand GPR Amount",
    //   dataIndex: "earned_gpr_brand_file",
    //   key: "earned_gpr_brand_file"
    // },
    {
      title: "Rebate Statement",
      key: "action",
      render: (record) => (
        <div className="flex gap-2">
          <Button onClick={() => downloadFile(record)} loading={loading === record.Id}>Download</Button>
        </div>
      ),
    },
  ];
  const LocColumns = [
    // {
    //   title: "File ID",
    //   dataIndex: "FileID",
    //   key: "FileID",
    // },
    {
      title: "Loc ID",
      dataIndex: "LocID",
      key: "LocID",
    },
    {
      title: "Account ID",
      dataIndex: "Acct_ID",
      key: "Acct_ID",
    },
    {
      title: "Customer Account ID",
      dataIndex: "CustomerAccountID",
      key: "CustomerAccountID",
    },

    {
      title: "Primary Account ID",
      dataIndex: "PrimaryAccountID",
      key: "PrimaryAccountID",
      render: (text, record) => (
        <span className="flex gap-2">{text === null ? "null" : text}</span>
      ),
    },

    {
      title: "Customer Chain Name",
      dataIndex: "CustomerChainName",
      key: "CustomerChainName",
    },

    {
      title: "Account Name",
      dataIndex: "Acct_Name",
      key: "Acct_Name",
    },
    {
      title: "Processed At",
      dataIndex: "ProcessedAt",
      key: "ProcessedAt",
      render: (value) =>
        value ? new Date(value).toLocaleDateString("en-US").replace(/\//g, "-") : "null"

    },

  ]
  //  const handleExportRebate = async () => {
  //       const exportData = selectedFileData;
  //       const headers = [
  //         "Account Number",
  //         "Account Name",
  //         "GCR Ratio",
  //         "SGCR Ratio",
  //         "GPR Ratio",
  //         "Eligible Generic SGCR",
  //         "Eligible Generic GPR",
  //         "Eligible Brand SGCR",
  //         "Eligible Brand GPR",
  //         "Email",
  //         "Generic SGCR Amount",
  //         "Generic GPR Amount",
  //         "Brand SGCR amount",
  //         "Brand GPR Amount",
  //         "Status"
  //       ];

  //       const rows = exportData.map((item) => [
  //         item?.accountNumber,
  //         item?.accountName,
  //         item?.gcrPer,
  //         item?.sgcrPer,
  //         item?.gprPer,
  //         item?.eligiblegenericsgcr,
  //         item?.eligiblegenericgpr,
  //         item?.eligiblebrandsgcr,
  //         item?.eligiblebrandgpr,
  //         item?.email,
  //         item?.genericsgcramount,
  //         item?.genericgpramount,
  //         item?.brandsgcramount,
  //         item?.brandgpramount,
  //         item?.status
  //       ]);

  //       // Combine headers and data
  //       const worksheetData = [headers, ...rows];

  //       // Create worksheet and workbook
  //       const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
  //       const workbook = XLSX.utils.book_new();
  //       XLSX.utils.book_append_sheet(workbook, worksheet, "Rebate file Report");

  //       // Export the Excel file
  //       const timestamp = new Date()
  //           .toISOString()
  //           .replace(/[:.]/g, "-");  
  //       XLSX.writeFile(workbook, `ProcessedRebate_${timestamp}.xlsx`);
  //   };

  // const handleExportRebate = async () => {
  //   const exportData = selectedFileData;

  //   const headers = [
  //     "File ID",
  //     "Customer Name",
  //     "Customer Group",
  //     "Account Number",
  //     "Account Name",
  //     "Email",
  //     "Statement Date",

  //     // FILE % values
  //     "File GCR %",
  //     "File SGCR %",
  //     "File GPR %",
  //     "File Generic SGCR %",
  //     "File Generic GPR %",
  //     "File Brand SGCR %",
  //     "File Brand GPR %",

  //     // SYSTEM % values
  //     "System GCR %",
  //     "System SGCR %",
  //     "System GPR %",
  //     "System Generic SGCR %",
  //     "System Generic GPR %",
  //     "System Brand SGCR %",
  //     "System Brand GPR %",

  //     // Dollar amounts
  //     "Generic SGCR Amount",
  //     "Generic GPR Amount",
  //     "Brand SGCR Amount",
  //     "Brand GPR Amount",

  //     // Eligibility
  //     "Eligible Generic SGCR",
  //     "Eligible Generic GPR",
  //     "Eligible Brand SGCR",
  //     "Eligible Brand GPR",

  //     "Total Generic Amount",
  //     "Total Brand Amount",
  //     "Total Rebate Amount"
  //   ];

  //   const rows = exportData.map((item) => [
  //     item?.FileId,
  //     item?.customerName,
  //     item?.customerGroup,
  //     item?.accountNumber,
  //     item?.accountName,
  //     item?.email,
  //     item?.statementDate,

  //     // FILE percentages
  //     item?.gcrPer,
  //     item?.sgcrPer,
  //     item?.gprPer,
  //     item?.genericsgcrper,
  //     item?.genericgprper,
  //     item?.brandsgcrper,
  //     item?.brandgprper,

  //     // SYSTEM percentages
  //     item?.sys_GCR_Percentage,
  //     item?.sys_SGCR_Percentage,
  //     item?.sys_GPR_Percentage,
  //     item?.sys_generic_sgcr_per,
  //     item?.sys_generic_gpr_per,
  //     item?.sys_brand_sgcr_per,
  //     item?.sys_brand_gpr_per,

  //     // Dollar amounts
  //     item?.genericsgcramount,
  //     item?.genericgpramount,
  //     item?.brandsgcramount,
  //     item?.brandgpramount,

  //     // Eligibility
  //     item?.eligiblegenericsgcr,
  //     item?.eligiblegenericgpr,
  //     item?.eligiblebrandsgcr,
  //     item?.eligiblebrandgpr,

  //     item?.totalgenericamount,
  //     item?.totalbrandamount,
  //     item?.totalRebateamount,
  //   ]);

  //   const worksheetData = [headers, ...rows];

  //   const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, "Rebate Audited Data");

  //   const timestamp = new Date().toISOString().replace(/[:.]/g, "-");
  //   XLSX.writeFile(workbook, `RebateAudited_${timestamp}.xlsx`);
  // };

  const handleExportRebate = async () => {
      const exportData = selectedFileData;
  
      const headers = [
        "Id",
        "File ID",
        "customer Group",
        "customer Name",
        "Account Number",
        "Account Name",
        "Email",
        "SYS Total RX",
        "SYS Speciality",
        "SYS Generic Rx",
        "MCK GCR %",
        "MCK GPR %",
        "MCK SGCR % ",
        "SYS GCR %",
        "SYS SGCR % ",
        "SYS GPR %",
        "MCK Generic GCR Rebate %",
        "MCK Generic GPR Rebate %",
        "MCK Brand GCR Rebate %",
        "MCK Brand GPR Rebate %",
        "SYS Generic GCR  %",
        "SYS Generic GPR  %",
        "SYS Brand GCR  %",
        "SYS Brand GPR  %",
        // "MCK Generic GCR Amount",
        // "MCK Generic GPR Amount",
        // "MCK Brand GCR Amount",
        // "MCK Brand GPR Amount",
        "SYS Generic GCR Amount",
        "SYS Generic GPR Amount",
        "SYS Brand GCR Amount",
        "SYS Brand GPR  Amount",
        // "Exception Reason"
      ];
  
      const rows = exportData.map((item) => [
        item?.Id,
        item?.FileId,
        item?.customerGroup,
        item?.customerName,
        item?.accountNumber,
        item?.accountName,
        item?.email,
  
        item?.sys_Total_Rx,
        item?.sys_Specialty,
        item?.sys_Generic_Rx,
  
        // File vs System Percentages
        item?.gcrPer,
        item?.gprPer,
        item?.sgcrPer,
        item?.sys_GCR_Percentage,
        item?.sys_SGCR_Percentage,
        item?.sys_GPR_Percentage,
  
        // Granular Percentages
        item?.genericsgcrper,
        item?.genericgprper,
        item?.brandsgcrper,
        item?.brandgprper,
  
  
        item?.sys_generic_sgcr_per,
        item?.sys_generic_gpr_per,
        item?.sys_brand_sgcr_per,
        item?.sys_brand_gpr_per,
  
        // Amounts
        // item?.earned_gcr_generic_file,
        // // item?.sys_generic_sgcr_amt,
        // item?.earned_gpr_generic_file,
        // // item?.sys_generic_gpr_amt,
        // item?.earned_gcr_brand_file,
        // // item?.sys_brand_sgcr_amt,
        // item?.earned_gpr_brand_file,
        // // item?.sys_brand_gpr_amt,
  
        // Eligible
        item?.eligiblegenericsgcr,
        item?.eligiblegenericgpr,
        item?.eligiblebrandsgcr,
        item?.eligiblebrandgpr,
  
        // item?.exceptionReason
      ]);
  
      const worksheetData = [headers, ...rows];
      const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Rebate Comparison");
  
      const timestamp = new Date().toISOString().replace(/[:.]/g, "-");
      XLSX.writeFile(workbook, `RebateAudited_${timestamp}.xlsx`);
    };


  // const handleExportCOgs = async () => {
  //   const exportData = selectedFileData;
  //   const headers = [
  //     "File ID",
  //     "Account Id",
  //     "Lock ID",
  //     "CUR BRX File",
  //     "COG",
  //     "GCR",
  //     "Month",
  //     "EmailStatus",
  //   ];

  //   const rows = exportData.map((item) => [
  //     item?.FileId,
  //     item?.ACCT_ID,
  //     item?.INA_LOC_ID === null ? "null" : item?.INA_LOC_ID,
  //     item?.Current_BRX_COG,
  //     item?.Final_COGS,
  //     item?.GCR,
  //     item?.Month,
  //     item?.EmailStatus,
  //   ]);

  //   // Combine headers and data
  //   const worksheetData = [headers, ...rows];

  //   // Create worksheet and workbook
  //   const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, "COGS file Report");

  //   // Export the Excel file
  //   const timestamp = new Date()
  //     .toISOString()
  //     .replace(/[:.]/g, "-");
  //   XLSX.writeFile(workbook, `ProcessedCOGS_${timestamp}.xlsx`);
  // };
const handleExportCOgs = async () => {
    const exportData = selectedFileData;
    const headers = [
      "File ID",
      "Primary Account",
      "Account Id",
      "Lock ID",
      "Store Name",
      "MCK RX Amount",
      "MCK GRX Amount",
      "MCK HIV Amount",
      "MCK GCR %",
      "Portal RX Amount",
      "Portal Generic RX Amount",
      "Portal HIV Amount",
      "Portal GCR %",
      "RX DIFF",
      "GRX DIFF",
      "HIV DIFF",
      "GCR DIFF",
    ];

    const rows = exportData.map((item) => [
      item?.FileId,
      item?.PRIMARY_ACCT,
      item?.ACCT_ID,
      // item?.LockID === null ? "null" : item?.LockID,
      item?.INA_LOC_ID === null ? "null" : item?.INA_LOC_ID,
      item?.STORE_NAME,
      item?.RX_AMT,
      item?.GRX_AMT,
      item?.HIV_AMT,
      item?.GCR,
      item?.Portal_RX,
      item?.Portal_GRX,
      item?.Portal_HIV,
      item?.Portal_GCR,
      item?.RX_DIFF,
      item?.GRX_DIFF,
      item?.HIV_DIFF,
      item?.GCR_DIFF,
    ]);

    // Combine headers and data
    const worksheetData = [headers, ...rows];

    // Create worksheet and workbook
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "COGS file Report");

    // Export the Excel file
    const timestamp = new Date()
      .toISOString()
      .replace(/[:.]/g, "-");
    XLSX.writeFile(workbook, `CogsAudited_${timestamp}.xlsx`);
  };
  return (
    <Modal
      style={{ marginTop: "-60px" }}
      title={
        <div
          style={{
            borderBottom: "1px solid #f0f0f0",
            padding: "16px 24px",
            marginLeft: -24,
            marginRight: -24,
            marginTop: -16,
            fontSize: "16px",
            fontWeight: 500,
            color: "#262626",
            display: "flex",
            alignItems: "center",
          }}
        >
          Files
        </div>
      }
      open={open}
      onCancel={hide}
      width="80%"
      destroyOnClose={true}
      maskClosable={false}
      keyboard={false}
      className="user-modal"
      closeIcon={<CloseOutlined />}
      footer={
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "8px",
            borderTop: "1px solid #f0f0f0",
            padding: "16px 0",
            marginTop: "24px",
          }}
        ></div>
      }
      styles={{
        padding: "24px",
        maxHeight: "80vh",
        overflowY: "auto",
      }}
    >
      <div className="flex justify-between items-center mt-3">
        <div>
          <span className="cardtitle ">{fileData?.FileName}</span>
        </div>
        {
          (fileType === "Rebate" || fileType === "COGS") && (
            <div>
              <Button
                type="primary"
                icon={<DownloadOutlined />}
                onClick={() => {
                  fileType === "Rebate" ?
                    handleExportRebate()
                    : handleExportCOgs()
                }}
                className="w-[100px] ml-4"
              >
                Export
              </Button>

            </div>
          )
        }
      </div>
      <div style={{ marginTop: "24px" }}>
        <Table
          columns={fileType === "COGS" ? CogsCoumn : fileType === "Rebate" ? Rebatecolumns : LocColumns}
          dataSource={selectedFileData}
          scroll={{ x: "max-content" }}
          rowKey="id"
          size="middle"
          loading={isLoading}
          className="custom-table user-tbl"
          pagination={{
            pageSize: pagination,
            showSizeChanger: true,
            showTotal: (total) => `Total ${total} accounts`,
            onShowSizeChange: (current, size) => {
              setPagination(size);
            },
          }}
        />
      </div>
      <style>
        {`.custom-country-dropdown {
          width: 220px !important; 
          }
          .remove-caret .ant-select-selection-search input {
  caret-color: transparent !important;
  // color: transparent !important;     
  background-color: transparent;       
}     
`}
      </style>
    </Modal>
  );
};

export default AutomationFileModal;
